/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Clever Analytics Users Public API
 * OpenAPI spec version: 1.0.0
 */
import { usersInstance } from '../../api/client';
export type ExportCompaniesPlanSource = typeof ExportCompaniesPlanSource[keyof typeof ExportCompaniesPlanSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportCompaniesPlanSource = {
  DEFAULT: 'DEFAULT',
  TRIAL: 'TRIAL',
  MANUAL: 'MANUAL',
  PAID: 'PAID',
} as const;

export type ExportCompaniesPlan = typeof ExportCompaniesPlan[keyof typeof ExportCompaniesPlan];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportCompaniesPlan = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export type ExportCompaniesParams = {
/**
 * Company country
 */
country?: string;
/**
 * Search in company name and number
 */
search?: string;
/**
 * Plan type
 */
plan?: ExportCompaniesPlan;
/**
 * Plan source
 */
planSource?: ExportCompaniesPlanSource;
/**
 * Plan is (not) expired 
 */
planValid?: boolean;
/**
 * Company has custom prices
 */
hasCustomPrices?: boolean;
};

/**
 * User company relation approval state
 */
export type ExportUsersApprovalStateItem = typeof ExportUsersApprovalStateItem[keyof typeof ExportUsersApprovalStateItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportUsersApprovalStateItem = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
} as const;

export type ExportUsersParams = {
/**
 * Search in user email, company name and number
 */
search?: string;
/**
 * User company relation approval state
 */
approvalState?: ExportUsersApprovalStateItem[];
};

/**
 * User company relation approval state
 */
export type GetUsersWithCompanyRelationApprovalStateItem = typeof GetUsersWithCompanyRelationApprovalStateItem[keyof typeof GetUsersWithCompanyRelationApprovalStateItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersWithCompanyRelationApprovalStateItem = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
} as const;

export type GetUsersWithCompanyRelationSortDir = typeof GetUsersWithCompanyRelationSortDir[keyof typeof GetUsersWithCompanyRelationSortDir];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersWithCompanyRelationSortDir = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUsersWithCompanyRelationSortCol = typeof GetUsersWithCompanyRelationSortCol[keyof typeof GetUsersWithCompanyRelationSortCol];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersWithCompanyRelationSortCol = {
  ID: 'ID',
  EMAIL: 'EMAIL',
  CREATED: 'CREATED',
} as const;

export type GetUsersWithCompanyRelationParams = {
/**
 * Page number (starting as 1)
 */
page?: number;
/**
 * Page size (default: 100)
 */
size?: number;
sortCol?: GetUsersWithCompanyRelationSortCol;
sortDir?: GetUsersWithCompanyRelationSortDir;
/**
 * Search in user email, company name and number
 */
search?: string;
/**
 * User company relation approval state
 */
approvalState?: GetUsersWithCompanyRelationApprovalStateItem[];
};

export type GetCompaniesPlanSource = typeof GetCompaniesPlanSource[keyof typeof GetCompaniesPlanSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompaniesPlanSource = {
  DEFAULT: 'DEFAULT',
  TRIAL: 'TRIAL',
  MANUAL: 'MANUAL',
  PAID: 'PAID',
} as const;

export type GetCompaniesPlan = typeof GetCompaniesPlan[keyof typeof GetCompaniesPlan];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompaniesPlan = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export type GetCompaniesSortDir = typeof GetCompaniesSortDir[keyof typeof GetCompaniesSortDir];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompaniesSortDir = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCompaniesSortCol = typeof GetCompaniesSortCol[keyof typeof GetCompaniesSortCol];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompaniesSortCol = {
  ID: 'ID',
  NAME: 'NAME',
  PLAN_EXPIRATION: 'PLAN_EXPIRATION',
} as const;

export type GetCompaniesParams = {
/**
 * Page number (starting as 1)
 */
page?: number;
/**
 * Page size (default: 100)
 */
size?: number;
sortCol?: GetCompaniesSortCol;
sortDir?: GetCompaniesSortDir;
/**
 * Company country
 */
country?: string;
/**
 * Search in company name and number
 */
search?: string;
/**
 * Plan type
 */
plan?: GetCompaniesPlan;
/**
 * Plan source
 */
planSource?: GetCompaniesPlanSource;
/**
 * Plan is (not) expired 
 */
planValid?: boolean;
/**
 * Company has custom prices
 */
hasCustomPrices?: boolean;
};

export type GetCompanyPaymentsCurrency = typeof GetCompanyPaymentsCurrency[keyof typeof GetCompanyPaymentsCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyPaymentsCurrency = {
  CZK: 'CZK',
  EUR: 'EUR',
  GBP: 'GBP',
  RON: 'RON',
  USD: 'USD',
} as const;

export type GetCompanyPaymentsGateway = typeof GetCompanyPaymentsGateway[keyof typeof GetCompanyPaymentsGateway];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyPaymentsGateway = {
  STRIPE: 'STRIPE',
  BANK: 'BANK',
} as const;

export type GetCompanyPaymentsPlanType = typeof GetCompanyPaymentsPlanType[keyof typeof GetCompanyPaymentsPlanType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyPaymentsPlanType = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export type GetCompanyPaymentsPaymentStatus = typeof GetCompanyPaymentsPaymentStatus[keyof typeof GetCompanyPaymentsPaymentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyPaymentsPaymentStatus = {
  INITIALIZED: 'INITIALIZED',
  WAITING: 'WAITING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
  _INITIALIZED: ' INITIALIZED',
  _WAITING: ' WAITING',
} as const;

export type GetCompanyPaymentsPaymentType = typeof GetCompanyPaymentsPaymentType[keyof typeof GetCompanyPaymentsPaymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyPaymentsPaymentType = {
  CARD: 'CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
} as const;

export type GetCompanyPaymentsSortDir = typeof GetCompanyPaymentsSortDir[keyof typeof GetCompanyPaymentsSortDir];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyPaymentsSortDir = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCompanyPaymentsSortCol = typeof GetCompanyPaymentsSortCol[keyof typeof GetCompanyPaymentsSortCol];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyPaymentsSortCol = {
  ID: 'ID',
} as const;

export type GetCompanyPaymentsParams = {
/**
 * Page number (starting as 1)
 */
page?: number;
/**
 * Page size (default: 100)
 */
size?: number;
sortCol?: GetCompanyPaymentsSortCol;
sortDir?: GetCompanyPaymentsSortDir;
/**
 * Search in gateway id, company number, company name
 */
search?: string;
/**
 * Filter by invoice variable symbol (exact match)
 */
variableSymbol?: string;
/**
 * Payment type
 */
paymentType?: GetCompanyPaymentsPaymentType;
/**
 * Payment type
 */
paymentStatus?: GetCompanyPaymentsPaymentStatus;
/**
 * Plan type
 */
planType?: GetCompanyPaymentsPlanType;
/**
 * Gateway
 */
gateway?: GetCompanyPaymentsGateway;
/**
 * Currency
 */
currency?: GetCompanyPaymentsCurrency;
};

export type GetPaymentsCurrency = typeof GetPaymentsCurrency[keyof typeof GetPaymentsCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentsCurrency = {
  CZK: 'CZK',
  EUR: 'EUR',
  GBP: 'GBP',
  RON: 'RON',
  USD: 'USD',
} as const;

export type GetPaymentsGateway = typeof GetPaymentsGateway[keyof typeof GetPaymentsGateway];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentsGateway = {
  STRIPE: 'STRIPE',
  BANK: 'BANK',
} as const;

export type GetPaymentsPlanType = typeof GetPaymentsPlanType[keyof typeof GetPaymentsPlanType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentsPlanType = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export type GetPaymentsPaymentStatus = typeof GetPaymentsPaymentStatus[keyof typeof GetPaymentsPaymentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentsPaymentStatus = {
  INITIALIZED: 'INITIALIZED',
  WAITING: 'WAITING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
  _INITIALIZED: ' INITIALIZED',
  _WAITING: ' WAITING',
} as const;

export type GetPaymentsPaymentType = typeof GetPaymentsPaymentType[keyof typeof GetPaymentsPaymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentsPaymentType = {
  CARD: 'CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
} as const;

export type GetPaymentsSortDir = typeof GetPaymentsSortDir[keyof typeof GetPaymentsSortDir];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentsSortDir = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetPaymentsSortCol = typeof GetPaymentsSortCol[keyof typeof GetPaymentsSortCol];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentsSortCol = {
  ID: 'ID',
} as const;

export type GetPaymentsParams = {
/**
 * Page number (starting as 1)
 */
page?: number;
/**
 * Page size (default: 100)
 */
size?: number;
sortCol?: GetPaymentsSortCol;
sortDir?: GetPaymentsSortDir;
/**
 * Search in gateway id, company number, company name
 */
search?: string;
/**
 * Filter by invoice variable symbol (exact match)
 */
variableSymbol?: string;
/**
 * Payment type
 */
paymentType?: GetPaymentsPaymentType;
/**
 * Payment type
 */
paymentStatus?: GetPaymentsPaymentStatus;
/**
 * Plan type
 */
planType?: GetPaymentsPlanType;
/**
 * Gateway
 */
gateway?: GetPaymentsGateway;
/**
 * Currency
 */
currency?: GetPaymentsCurrency;
};

export type GetCompanyFeatures200 = {[key: string]: CompanyFeatureTo};

export type GetCompanyPlansParams = {
/**
 * Feature is shown in menu 
 */
inMenu?: boolean;
/**
 * Feature is shown in plan 
 */
inPlan?: boolean;
};

export type GetCountryPlansIncludingManualParams = {
/**
 * Feature is shown in menu 
 */
inMenu?: boolean;
/**
 * Feature is shown in plan 
 */
inPlan?: boolean;
};

export type GetCountryPlansParams = {
/**
 * Feature is shown in menu 
 */
inMenu?: boolean;
/**
 * Feature is shown in plan 
 */
inPlan?: boolean;
};

export type GetDefaultFeatures200 = {[key: string]: CompanyFeatureTo};

export type GetPlanParams = {
companyId?: number;
/**
 * Feature is shown in menu 
 */
inMenu?: boolean;
/**
 * Feature is shown in plan 
 */
inPlan?: boolean;
};

export type GetInternalCompanyUsersStateItem = typeof GetInternalCompanyUsersStateItem[keyof typeof GetInternalCompanyUsersStateItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInternalCompanyUsersStateItem = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
} as const;

export type GetInternalCompanyUsersParams = {
state?: GetInternalCompanyUsersStateItem[];
};

export type GetInternalCompanyFeatures200 = {[key: string]: CompanyFeatureTo};

export type GetAllParams = {
/**
 * Search in name and email
 */
search?: string;
/**
 * News Language setting
 */
settingsLanguage?: string;
/**
 * News Language setting
 */
settingsNewsLanguage?: string;
};

export type GetCompanyUsersStateItem = typeof GetCompanyUsersStateItem[keyof typeof GetCompanyUsersStateItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyUsersStateItem = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
} as const;

export type GetCompanyUsersParams = {
state?: GetCompanyUsersStateItem[];
};

export type GetUsersSortDir = typeof GetUsersSortDir[keyof typeof GetUsersSortDir];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersSortDir = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUsersSortCol = typeof GetUsersSortCol[keyof typeof GetUsersSortCol];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersSortCol = {
  CREATED: 'CREATED',
  EMAIL: 'EMAIL',
  NAME: 'NAME',
  LAST_ACTIVITY: 'LAST_ACTIVITY',
} as const;

export type GetUsersParams = {
/**
 * Page number (starting as 1)
 */
page?: number;
/**
 * Page size (default: 100)
 */
size?: number;
sortCol?: GetUsersSortCol;
sortDir?: GetUsersSortDir;
/**
 * Search in name and email
 */
search?: string;
/**
 * News Language setting
 */
settingsLanguage?: string;
/**
 * News Language setting
 */
settingsNewsLanguage?: string;
};

export type SubscriptionPlanSource = typeof SubscriptionPlanSource[keyof typeof SubscriptionPlanSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPlanSource = {
  DEFAULT: 'DEFAULT',
  TRIAL: 'TRIAL',
  MANUAL: 'MANUAL',
  PAID: 'PAID',
} as const;

export type SubscriptionSubscriptionStatus = typeof SubscriptionSubscriptionStatus[keyof typeof SubscriptionSubscriptionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionSubscriptionStatus = {
  INCOMPLETE: 'INCOMPLETE',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  DELETED: 'DELETED',
} as const;

export interface Subscription {
  id?: number;
  subscriptionStatus: SubscriptionSubscriptionStatus;
  companyId?: number;
  planSource: SubscriptionPlanSource;
  planId: number;
  planPeriodId?: number;
  expiresAt?: string;
  createdAt?: string;
  statusUpdatedAt?: string;
  updatedAt?: string;
}

export interface StreamingResponseBody {}

export type CompanyUserToGrantsItem = typeof CompanyUserToGrantsItem[keyof typeof CompanyUserToGrantsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyUserToGrantsItem = {
  COMPANY_DETAIL_EDIT: 'COMPANY_DETAIL_EDIT',
  PAYMENT_CREATE: 'PAYMENT_CREATE',
  CONTRACT_SIGN: 'CONTRACT_SIGN',
} as const;

export type CompanyUserToRole = typeof CompanyUserToRole[keyof typeof CompanyUserToRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyUserToRole = {
  USER: 'USER',
  STATUTORY: 'STATUTORY',
} as const;

export type CompanyUserToApprovalState = typeof CompanyUserToApprovalState[keyof typeof CompanyUserToApprovalState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyUserToApprovalState = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
} as const;

export interface CompanyUserPage {
  data: CompanySimpleUserTo[];
  totalSize: number;
}

export interface CompanyPage {
  data: CompanyTo[];
  totalSize: number;
}

export type CountryToPaymentMethodsItem = typeof CountryToPaymentMethodsItem[keyof typeof CountryToPaymentMethodsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CountryToPaymentMethodsItem = {
  CARD: 'CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
} as const;

export type CountryToPopulatorFieldsItem = typeof CountryToPopulatorFieldsItem[keyof typeof CountryToPopulatorFieldsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CountryToPopulatorFieldsItem = {
  VAT: 'VAT',
  FORM: 'FORM',
  ADDRESS: 'ADDRESS',
} as const;

export interface CountryTo {
  id: string;
  name: string;
  localName: string;
  language: string;
  currency: CurrencyTo;
  phoneCountryCode: string;
  isAuthorized: boolean;
  isCompanyRequired: boolean;
  hasCompanyValidator: boolean;
  hasCompanyPopulator: boolean;
  populatorFields: CountryToPopulatorFieldsItem[];
  paymentMethods: CountryToPaymentMethodsItem[];
}

export interface PaymentPage {
  data: PaymentTo[];
  totalSize: number;
}

export type CompanyToPlanSource = typeof CompanyToPlanSource[keyof typeof CompanyToPlanSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyToPlanSource = {
  DEFAULT: 'DEFAULT',
  TRIAL: 'TRIAL',
  MANUAL: 'MANUAL',
  PAID: 'PAID',
} as const;

export interface CompanyTo {
  id: number;
  country: string;
  companyNumber: string;
  name: string;
  plan: PlanSimpleTo;
  plans: PlanTo[];
  planSource: CompanyToPlanSource;
  subscriptions: SubscriptionTo[];
  detail?: CompanyDetailTo;
  hasCustomPrices: boolean;
  createdAt: string;
  updatedAt: string;
}

export type CompanyFeatureToMode = typeof CompanyFeatureToMode[keyof typeof CompanyFeatureToMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyFeatureToMode = {
  TRIAL: 'TRIAL',
  FULL: 'FULL',
} as const;

export type CompanyFeatureToPlanType = typeof CompanyFeatureToPlanType[keyof typeof CompanyFeatureToPlanType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyFeatureToPlanType = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export interface CompanyFeatureTo {
  planId?: number;
  planType?: CompanyFeatureToPlanType;
  menu?: boolean;
  mode?: CompanyFeatureToMode;
}

export type CompanyFeatureModeToMode = typeof CompanyFeatureModeToMode[keyof typeof CompanyFeatureModeToMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyFeatureModeToMode = {
  TRIAL: 'TRIAL',
  FULL: 'FULL',
} as const;

export interface CompanyFeatureModeTo {
  mode?: CompanyFeatureModeToMode;
}

export interface UserMetadata {
  common: CommonMetadata;
  can: CanMetadata;
}

export interface CompanyUserTo {
  id: number;
  userId: string;
  userEmail?: string;
  userName?: string;
  userMetadata: UserMetadata;
  companyId: number;
  companyCountry: string;
  companyNumber: string;
  companyName?: string;
  companyPlan: PlanSimpleTo;
  approvalState: CompanyUserToApprovalState;
  role: CompanyUserToRole;
  grants: CompanyUserToGrantsItem[];
  createdAt: string;
  updatedAt: string;
}

export interface UserTo {
  id: string;
  email: string;
  name: string;
  identities: string;
  phone?: PhoneTo;
  company: CompanySimpleUserTo[];
  userMetadata: UserMetadata;
  lastLogin?: string;
  loginsCount: number;
  isBlocked: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PhoneMetadata {
  countryCode?: string;
  phoneNumber?: string;
}

export interface NewsMetadata {
  language: string;
}

export interface SettingsMetadata {
  language: string;
  news: NewsMetadata;
}

export interface CompanyMetadata {
  companyNumber?: string;
  companyName?: string;
  countryCode?: string;
}

export interface CommonMetadata {
  phone: PhoneMetadata;
}

export interface CanMetadata {
  settings: SettingsMetadata;
  companies?: CompanyMetadata[];
}

export interface UserListSettingsTo {
  language: string;
  newsLanguage: string;
}

export interface UserListTo {
  id: string;
  email: string;
  name: string;
  identities: string;
  phone?: PhoneTo;
  settings: UserListSettingsTo;
  company: CompanySimpleUserTo[];
  activityAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UserPage {
  data: UserListTo[];
  totalSize: number;
}

export type PlanSimpleToType = typeof PlanSimpleToType[keyof typeof PlanSimpleToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanSimpleToType = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export interface PlanSimpleTo {
  id: number;
  name: string;
  type: PlanSimpleToType;
  country: string;
}

export type CompanySimpleUserToGrantsItem = typeof CompanySimpleUserToGrantsItem[keyof typeof CompanySimpleUserToGrantsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanySimpleUserToGrantsItem = {
  COMPANY_DETAIL_EDIT: 'COMPANY_DETAIL_EDIT',
  PAYMENT_CREATE: 'PAYMENT_CREATE',
  CONTRACT_SIGN: 'CONTRACT_SIGN',
} as const;

export type CompanySimpleUserToRole = typeof CompanySimpleUserToRole[keyof typeof CompanySimpleUserToRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanySimpleUserToRole = {
  USER: 'USER',
  STATUTORY: 'STATUTORY',
} as const;

export type CompanySimpleUserToApprovalState = typeof CompanySimpleUserToApprovalState[keyof typeof CompanySimpleUserToApprovalState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanySimpleUserToApprovalState = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
} as const;

export interface CompanySimpleUserTo {
  id: number;
  userId: string;
  userEmail?: string;
  companyId: number;
  companyCountry: string;
  companyNumber: string;
  companyName?: string;
  companyPlan: PlanSimpleTo;
  approvalState: CompanySimpleUserToApprovalState;
  role: CompanySimpleUserToRole;
  grants: CompanySimpleUserToGrantsItem[];
  createdAt: string;
  updatedAt: string;
}

export interface LanguageTo {
  id: string;
  name: string;
  localName: string;
  isDefault: boolean;
}

export type CompanyPatchRequestCompanyForm = typeof CompanyPatchRequestCompanyForm[keyof typeof CompanyPatchRequestCompanyForm];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyPatchRequestCompanyForm = {
  NATURAL_PERSON: 'NATURAL_PERSON',
  JURIDICAL_PERSON: 'JURIDICAL_PERSON',
} as const;

export interface CompanyPatchRequest {
  vat?: string;
  address?: string;
  companyForm?: CompanyPatchRequestCompanyForm;
  contactName?: string;
  contactPosition?: string;
  contactEmail?: string;
  contactPhone?: PhoneUpdateRequest;
}

export interface UserPatchRequest {
  name?: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  newsLanguage?: string;
  phone?: PhoneUpdateRequest;
  company?: UserUpdateCompanyRequest;
}

export interface CompanyValidationResponse {
  name?: string;
}

export interface CompanyValidationRequest {
  /** @minLength 1 */
  countryCode: string;
  /** @minLength 1 */
  companyNumber: string;
}

export type CompanyUserAssignRequestRole = typeof CompanyUserAssignRequestRole[keyof typeof CompanyUserAssignRequestRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyUserAssignRequestRole = {
  USER: 'USER',
  STATUTORY: 'STATUTORY',
} as const;

export type CompanyUserAssignRequestState = typeof CompanyUserAssignRequestState[keyof typeof CompanyUserAssignRequestState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyUserAssignRequestState = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
} as const;

export interface CompanyUserAssignRequest {
  /** @minLength 1 */
  email: string;
  state: CompanyUserAssignRequestState;
  role: CompanyUserAssignRequestRole;
}

export interface SubscriptionCreateManualRequest {
  companyId: number;
  plan: number;
  expiresAt: string;
}

export type PaymentToStatus = typeof PaymentToStatus[keyof typeof PaymentToStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentToStatus = {
  INITIALIZED: 'INITIALIZED',
  WAITING: 'WAITING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
} as const;

export type PaymentToGateway = typeof PaymentToGateway[keyof typeof PaymentToGateway];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentToGateway = {
  STRIPE: 'STRIPE',
  BANK: 'BANK',
} as const;

export type PaymentToType = typeof PaymentToType[keyof typeof PaymentToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentToType = {
  CARD: 'CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
} as const;

export interface PaymentTo {
  id: number;
  type: PaymentToType;
  amount: number;
  amountTaxPercent: number;
  amountTax: number;
  amountTotal: number;
  currency: CurrencyTo;
  gateway: PaymentToGateway;
  gatewayId?: string;
  status: PaymentToStatus;
  createdAt: string;
  paidAt?: string;
  periodStart: string;
  periodEnd: string;
  dueDate?: string;
  details?: PaymentDetailsTo;
  billing: PaymentBillingTo;
  invoice: InvoiceTo[];
  subscription: PaymentSubscriptionTo;
  company: PaymentCompanyTo;
}

export type PaymentSubscriptionToStatus = typeof PaymentSubscriptionToStatus[keyof typeof PaymentSubscriptionToStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentSubscriptionToStatus = {
  INCOMPLETE: 'INCOMPLETE',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  DELETED: 'DELETED',
} as const;

export type PaymentSubscriptionToPlanPeriod = typeof PaymentSubscriptionToPlanPeriod[keyof typeof PaymentSubscriptionToPlanPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentSubscriptionToPlanPeriod = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export type PaymentSubscriptionToPlanType = typeof PaymentSubscriptionToPlanType[keyof typeof PaymentSubscriptionToPlanType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentSubscriptionToPlanType = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export interface PaymentSubscriptionTo {
  id: number;
  planType: PaymentSubscriptionToPlanType;
  planPeriod?: PaymentSubscriptionToPlanPeriod;
  status: PaymentSubscriptionToStatus;
  statusUpdatedAt: string;
  expiresAt?: string;
  isActive: boolean;
}

export interface PaymentStripeTo {
  publicKey: string;
  clientSecret: string;
}

export interface PaymentDetailsTo {
  stripe?: PaymentStripeTo;
  bank?: PaymentBankTo;
}

export interface PaymentCompanyTo {
  id: number;
  companyNumber: string;
  name: string;
}

export interface PaymentBillingPhoneTo {
  countryCode: string;
  phoneNumber: string;
}

export interface PaymentBillingTo {
  address: string;
  vat?: string;
  email: string;
  phone: PaymentBillingPhoneTo;
}

export interface PaymentBankTo {
  account: string;
  iban: string;
  swift: string;
  variableSymbol: string;
}

export type InvoiceToType = typeof InvoiceToType[keyof typeof InvoiceToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceToType = {
  PAYMENT_REQUEST: 'PAYMENT_REQUEST',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
} as const;

export interface InvoiceTo {
  id: number;
  paymentId: number;
  type: InvoiceToType;
  number: string;
  variable: string;
  createdAt: string;
  dueDate?: string;
}

export type SubscriptionCreatePaidRequestPaymentType = typeof SubscriptionCreatePaidRequestPaymentType[keyof typeof SubscriptionCreatePaidRequestPaymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionCreatePaidRequestPaymentType = {
  CARD: 'CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
} as const;

export interface SubscriptionCreatePaidBillingRequest {
  /** @minLength 1 */
  address: string;
  vat?: string;
  /** @minLength 1 */
  email: string;
  phone: PhoneUpdateRequest;
}

export interface SubscriptionCreatePaidRequest {
  companyId: number;
  periodId: number;
  paymentType: SubscriptionCreatePaidRequestPaymentType;
  billing: SubscriptionCreatePaidBillingRequest;
}

export type UserCompanyAssignRequestRole = typeof UserCompanyAssignRequestRole[keyof typeof UserCompanyAssignRequestRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserCompanyAssignRequestRole = {
  USER: 'USER',
  STATUTORY: 'STATUTORY',
} as const;

export type UserCompanyAssignRequestState = typeof UserCompanyAssignRequestState[keyof typeof UserCompanyAssignRequestState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserCompanyAssignRequestState = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
} as const;

export interface UserCompanyAssignRequest {
  /** @minLength 1 */
  country: string;
  /** @minLength 1 */
  companyNumber: string;
  state: UserCompanyAssignRequestState;
  role: UserCompanyAssignRequestRole;
}

export interface CompanyAppMetadata {
  companyId?: number;
  companyName?: string;
  companyNumber?: string;
  countryCode?: string;
  updatedAt: number;
}

export interface CompanyMetadataRequest {
  /** @minLength 1 */
  countryCode: string;
  /** @minLength 1 */
  companyNumber: string;
}

export type MediaTypeParameters = {[key: string]: string};

export interface MediaType {
  type?: string;
  subtype?: string;
  parameters?: MediaTypeParameters;
  qualityValue?: number;
  charset?: string;
  concrete?: boolean;
  wildcardType?: boolean;
  wildcardSubtype?: boolean;
  subtypeSuffix?: string;
}

export interface HttpRange {}

export interface HttpMethod {}

export type HttpHeadersAcceptLanguageItem = {
  range?: string;
  weight?: number;
};

export type HttpHeadersAll = {[key: string]: string};

export type HttpHeadersHostAddress = {
  hostAddress?: string;
  address?: string;
  hostName?: string;
  linkLocalAddress?: boolean;
  multicastAddress?: boolean;
  anyLocalAddress?: boolean;
  loopbackAddress?: boolean;
  siteLocalAddress?: boolean;
  mcglobal?: boolean;
  mcnodeLocal?: boolean;
  mclinkLocal?: boolean;
  mcsiteLocal?: boolean;
  mcorgLocal?: boolean;
  canonicalHostName?: string;
};

export type HttpHeadersHost = {
  hostString?: string;
  address?: HttpHeadersHostAddress;
  port?: number;
  unresolved?: boolean;
  hostName?: string;
};

export interface ContentDisposition {
  type?: string;
  name?: string;
  filename?: string;
  charset?: string;
  attachment?: boolean;
  formData?: boolean;
  inline?: boolean;
}

export interface HttpHeaders {
  host?: HttpHeadersHost;
  empty?: boolean;
  location?: string;
  all?: HttpHeadersAll;
  lastModified?: number;
  date?: number;
  contentLength?: number;
  origin?: string;
  contentType?: MediaType;
  range?: HttpRange[];
  connection?: string[];
  cacheControl?: string;
  pragma?: string;
  expires?: number;
  allow?: HttpMethod[];
  acceptCharset?: string[];
  contentLanguage?: string;
  etag?: string;
  acceptLanguage?: HttpHeadersAcceptLanguageItem[];
  basicAuth?: string;
  contentDisposition?: ContentDisposition;
  accept?: MediaType[];
  acceptLanguageAsLocales?: string[];
  acceptPatch?: MediaType[];
  accessControlAllowCredentials?: boolean;
  accessControlAllowHeaders?: string[];
  accessControlAllowMethods?: HttpMethod[];
  accessControlAllowOrigin?: string;
  accessControlExposeHeaders?: string[];
  accessControlMaxAge?: number;
  accessControlRequestHeaders?: string[];
  accessControlRequestMethod?: HttpMethod;
  bearerAuth?: string;
  ifMatch?: string[];
  ifNoneMatch?: string[];
  ifUnmodifiedSince?: number;
  upgrade?: string;
  vary?: string[];
  ifModifiedSince?: number;
}

export interface ErrorResponse {
  timestamp: number;
  status: string;
  message?: string;
  errors?: string[];
}

export interface CustomPriceRequest {
  planPeriodId: number;
  price: number;
}

export interface PhoneTo {
  countryCode: string;
  phoneNumber: string;
}

export type CompanyDetailToForm = typeof CompanyDetailToForm[keyof typeof CompanyDetailToForm];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyDetailToForm = {
  NATURAL_PERSON: 'NATURAL_PERSON',
  JURIDICAL_PERSON: 'JURIDICAL_PERSON',
} as const;

export interface CompanyDetailTo {
  vat?: string;
  address?: string;
  form?: CompanyDetailToForm;
  contactName?: string;
  contactPosition?: string;
  contactEmail?: string;
  contactPhone?: PhoneTo;
}

export type CompanyPutRequestCompanyForm = typeof CompanyPutRequestCompanyForm[keyof typeof CompanyPutRequestCompanyForm];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyPutRequestCompanyForm = {
  NATURAL_PERSON: 'NATURAL_PERSON',
  JURIDICAL_PERSON: 'JURIDICAL_PERSON',
} as const;

export interface CompanyPutRequest {
  vat?: string;
  /** @minLength 1 */
  address: string;
  companyForm: CompanyPutRequestCompanyForm;
  /** @minLength 1 */
  contactName: string;
  /** @minLength 1 */
  contactPosition: string;
  /** @minLength 1 */
  contactEmail: string;
  contactPhone: PhoneUpdateRequest;
}

export interface PaymentConfirmRequest {
  date: string;
}

export type SubscriptionToStatus = typeof SubscriptionToStatus[keyof typeof SubscriptionToStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionToStatus = {
  INCOMPLETE: 'INCOMPLETE',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  DELETED: 'DELETED',
} as const;

export type SubscriptionToSource = typeof SubscriptionToSource[keyof typeof SubscriptionToSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionToSource = {
  DEFAULT: 'DEFAULT',
  TRIAL: 'TRIAL',
  MANUAL: 'MANUAL',
  PAID: 'PAID',
} as const;

export interface SubscriptionTo {
  id: number;
  companyId?: number;
  source: SubscriptionToSource;
  status: SubscriptionToStatus;
  statusUpdatedAt: string;
  period?: PlanPeriodTo;
  plan: PlanTo;
  expiresAt?: string;
  nexPaymentAt?: string;
  lastPayment?: SubscriptionPaymentTo;
  lastCompletedPayment?: SubscriptionPaymentTo;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  isRenewable: boolean;
  isCancellable: boolean;
}

export type SubscriptionPaymentToStatus = typeof SubscriptionPaymentToStatus[keyof typeof SubscriptionPaymentToStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPaymentToStatus = {
  INITIALIZED: 'INITIALIZED',
  WAITING: 'WAITING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
} as const;

export type SubscriptionPaymentToGateway = typeof SubscriptionPaymentToGateway[keyof typeof SubscriptionPaymentToGateway];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPaymentToGateway = {
  STRIPE: 'STRIPE',
  BANK: 'BANK',
} as const;

export interface SubscriptionPaymentTo {
  id: number;
  gateway: SubscriptionPaymentToGateway;
  status: SubscriptionPaymentToStatus;
  createdAt: string;
}

export type PlanToType = typeof PlanToType[keyof typeof PlanToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanToType = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export interface PlanTo {
  id: number;
  name: string;
  type: PlanToType;
  country: string;
  manualOnly: boolean;
  features: PlanFeatureTo[];
  periods: PlanPeriodTo[];
}

export type PlanPeriodToType = typeof PlanPeriodToType[keyof typeof PlanPeriodToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanPeriodToType = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export interface PlanPeriodTo {
  id: number;
  planId: number;
  type: PlanPeriodToType;
  price: number;
  currency: CurrencyTo;
  customPrice?: boolean;
}

export type PlanFeatureToMode = typeof PlanFeatureToMode[keyof typeof PlanFeatureToMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanFeatureToMode = {
  TRIAL: 'TRIAL',
  FULL: 'FULL',
} as const;

export interface PlanFeatureTo {
  feature: FeatureTo;
  mode: PlanFeatureToMode;
  menu?: boolean;
  plan?: boolean;
}

export type FeatureToType = typeof FeatureToType[keyof typeof FeatureToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeatureToType = {
  MARKET_NEWS: 'MARKET_NEWS',
  STOCK_EXCHANGE: 'STOCK_EXCHANGE',
  QUICK_TRADING: 'QUICK_TRADING',
  PURCHASE_PRICES: 'PURCHASE_PRICES',
  TRADING: 'TRADING',
  TRANSACTIONS_ORDERS: 'TRANSACTIONS_ORDERS',
  STORAGES: 'STORAGES',
  MARKETPLACE: 'MARKETPLACE',
  YIELD_PREDICTIONS: 'YIELD_PREDICTIONS',
} as const;

export interface FeatureModeTo {
  title: string;
  description: string;
}

export type FeatureToModes = {[key: string]: FeatureModeTo};

export interface FeatureTo {
  type: FeatureToType;
  icon: string;
  modes: FeatureToModes;
}

export type CurrencyToType = typeof CurrencyToType[keyof typeof CurrencyToType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrencyToType = {
  CZK: 'CZK',
  EUR: 'EUR',
  GBP: 'GBP',
  RON: 'RON',
  USD: 'USD',
} as const;

export interface CurrencyTo {
  type: CurrencyToType;
  precision: number;
}

export type UserValues = {[key: string]: unknown};

export type UserUserMetadata = {[key: string]: unknown};

export type UserAppMetadata = {[key: string]: unknown};

export type ProfileDataValues = {[key: string]: unknown};

export interface ProfileData {
  email?: string;
  email_verified?: boolean;
  name?: string;
  username?: string;
  given_name?: string;
  phone_number?: string;
  phone_verified?: boolean;
  family_name?: string;
  values?: ProfileDataValues;
}

export type IdentityValues = {[key: string]: unknown};

export interface Identity {
  connection?: string;
  user_id?: string;
  provider?: string;
  isSocial?: boolean;
  access_token?: string;
  profileData?: ProfileData;
  values?: IdentityValues;
}

export interface User {
  connection?: string;
  client_id?: string;
  /** @deprecated */
  password?: string[];
  verify_password?: boolean;
  username?: string;
  email?: string;
  email_verified?: boolean;
  verify_email?: boolean;
  phone_number?: string;
  phone_verified?: boolean;
  verify_phone_number?: boolean;
  user_id?: string;
  picture?: string;
  name?: string;
  nickname?: string;
  given_name?: string;
  family_name?: string;
  created_at?: string;
  updated_at?: string;
  identities?: Identity[];
  app_metadata?: UserAppMetadata;
  user_metadata?: UserUserMetadata;
  multifactor?: string[];
  last_ip?: string;
  last_login?: string;
  last_password_reset?: string;
  logins_count?: number;
  blocked?: boolean;
  values?: UserValues;
}

export interface UserUpdateCompanyRequest {
  /** @minLength 1 */
  countryCode: string;
  /** @minLength 1 */
  companyNumber: string;
}

export interface PhoneUpdateRequest {
  /** @minLength 1 */
  countryCode: string;
  /** @minLength 1 */
  phoneNumber: string;
}

export interface UserUpdateRequest {
  /** @minLength 1 */
  name: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language: string;
  phone: PhoneUpdateRequest;
  company?: UserUpdateCompanyRequest;
}

export type CustomPriceE2ERequestPeriod = typeof CustomPriceE2ERequestPeriod[keyof typeof CustomPriceE2ERequestPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomPriceE2ERequestPeriod = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export type CustomPriceE2ERequestPlan = typeof CustomPriceE2ERequestPlan[keyof typeof CustomPriceE2ERequestPlan];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomPriceE2ERequestPlan = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  TRADER: 'TRADER',
  PREMIUM: 'PREMIUM',
} as const;

export interface CustomPriceE2ERequest {
  plan: CustomPriceE2ERequestPlan;
  period: CustomPriceE2ERequestPeriod;
  price: number;
}




type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


  /**
 * @summary Set custom price for a company (E2E)
 */
export const e2eSetCustomPrice = (
    companyNumber: string,
    customPriceE2ERequest: CustomPriceE2ERequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/e2e/api/custom-price/company/${companyNumber}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customPriceE2ERequest
    },
      options);
    }
  
/**
 * @summary Delete all custom prices for a company (E2E)
 */
export const e2eDeleteAllCustomPrices = (
    companyNumber: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/e2e/api/custom-price/company/${companyNumber}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary List of all users [users:user:list or users:*:list]
 */
export const getUsers = (
    params?: GetUsersParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<UserPage>(
      {url: `/can-users/api/user`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update user profile information
 */
export const update = (
    userUpdateRequest: UserUpdateRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<User>(
      {url: `/can-users/api/user`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateRequest
    },
      options);
    }
  
/**
 * @summary Patch user profile information
 */
export const patch = (
    userPatchRequest: UserPatchRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<User>(
      {url: `/can-users/api/user`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userPatchRequest
    },
      options);
    }
  
/**
 * @summary Block user from logging in [users:user:block]
 */
export const block = (
    userId: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/user/${userId}/block`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Unblock user [users:user:block]
 */
export const unblock = (
    userId: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/user/${userId}/block`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Cancel paid subscription
 */
export const cancelSubscription = (
    subscriptionId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<SubscriptionTo>(
      {url: `/can-users/api/subscription/${subscriptionId}/cancel`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Manually confirm payment [users:payment:confirm]
 */
export const confirmPayment = (
    paymentId: number,
    paymentConfirmRequest: PaymentConfirmRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/payment/${paymentId}/confirm`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: paymentConfirmRequest
    },
      options);
    }
  
/**
 * @summary Manually cancell payment [users:payment:confirm]
 */
export const cancelPayment = (
    paymentId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/payment/${paymentId}/cancel`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Get company detail information by id
 */
export const getCompanyDetail = (
    companyId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyDetailTo>(
      {url: `/can-users/api/company/${companyId}/detail`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Update company detail information by id
 */
export const updateCompanyDetail = (
    companyId: number,
    companyPutRequest: CompanyPutRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyDetailTo>(
      {url: `/can-users/api/company/${companyId}/detail`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: companyPutRequest
    },
      options);
    }
  
/**
 * @summary Update company detail information by id
 */
export const patchCompanyDetail = (
    companyId: number,
    companyPatchRequest: CompanyPatchRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyDetailTo>(
      {url: `/can-users/api/company/${companyId}/detail`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: companyPatchRequest
    },
      options);
    }
  
/**
 * @summary Set or update a custom price for a company [users:company:plan]
 */
export const setCustomPrice = (
    companyId: number,
    customPriceRequest: CustomPriceRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/company/${companyId}/custom-price`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customPriceRequest
    },
      options);
    }
  
/**
 * @deprecated
 * @summary Set user approval state in a company [users:company:approve]
 */
export const setUserStateDeprecated = (
    userId: number,
    state: 'WAITING' | 'APPROVED' | 'BLOCKED',
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/company/user/${userId}/${state}`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Set user approval state in a company [users:company:approve]
 */
export const setUserState = (
    userCompanyId: number,
    state: 'WAITING' | 'APPROVED' | 'BLOCKED',
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/company/user/${userCompanyId}/state/${state}`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Set user role in a company [users:company:role]
 */
export const setUserRole = (
    userCompanyId: number,
    role: 'USER' | 'STATUTORY',
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/company/user/${userCompanyId}/role/${role}`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Handle payment status from gateway
 */
export const create = (
    createBody: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/public/api/payment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBody
    },
      options);
    }
  
/**
 * @summary Returns internal company metadata for multiple companies
 */
export const getMetadataList = (
    user: string,
    companyMetadataRequest: CompanyMetadataRequest[],
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyAppMetadata[]>(
      {url: `/can-users/internal/api/company/${user}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyMetadataRequest
    },
      options);
    }
  
/**
 * @summary List of all user companies [users:company:list or users:*:list]
 */
export const getUserCompanies = (
    userId: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanySimpleUserTo[]>(
      {url: `/can-users/api/user/${userId}/company`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Add user to selected company [users:company:assign]
 */
export const assignUserCompany = (
    userId: string,
    userCompanyAssignRequest: UserCompanyAssignRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/user/${userId}/company`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userCompanyAssignRequest
    },
      options);
    }
  
/**
 * @summary Create a new paid subscription
 */
export const createPaid = (
    subscriptionCreatePaidRequest: SubscriptionCreatePaidRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PaymentTo>(
      {url: `/can-users/api/subscription/paid`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subscriptionCreatePaidRequest
    },
      options);
    }
  
/**
 * @summary Create a new manual subscription [users:company:plan]
 */
export const createManual = (
    subscriptionCreateManualRequest: SubscriptionCreateManualRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<SubscriptionTo>(
      {url: `/can-users/api/subscription/manual`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subscriptionCreateManualRequest
    },
      options);
    }
  
/**
 * @summary List of all company users
 */
export const getCompanyUsers = (
    companyId: number,
    params?: GetCompanyUsersParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanySimpleUserTo[]>(
      {url: `/can-users/api/company/${companyId}/user`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Add user to selected company [users:company:assign]
 */
export const assignCompanyUser = (
    companyId: number,
    companyUserAssignRequest: CompanyUserAssignRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/company/${companyId}/user`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyUserAssignRequest
    },
      options);
    }
  
/**
 * @summary Validate company identification number in country specific registry
 */
export const validate = (
    companyValidationRequest: CompanyValidationRequest,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyValidationResponse>(
      {url: `/can-users/api/company/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyValidationRequest
    },
      options);
    }
  
/**
 * @summary List of all available languages
 */
export const getLanguages = (
    
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<LanguageTo[]>(
      {url: `/can-users/public/api/language`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Language detail
 */
export const getLanguage = (
    id: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<LanguageTo>(
      {url: `/can-users/public/api/language/${id}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get all users
 */
export const getAll = (
    params?: GetAllParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<UserPage>(
      {url: `/can-users/internal/api/user`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get user detail
 */
export const getInternalUser = (
    userId: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<UserTo>(
      {url: `/can-users/internal/api/user/${userId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get user by email
 */
export const getByEmail = (
    email: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<UserTo[]>(
      {url: `/can-users/internal/api/user/email/${email}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get default feature
 */
export const getInternalDefaultFeature = (
    feature: 'MARKET_NEWS' | 'STOCK_EXCHANGE' | 'QUICK_TRADING' | 'PURCHASE_PRICES' | 'TRADING' | 'TRANSACTIONS_ORDERS' | 'STORAGES' | 'MARKETPLACE' | 'YIELD_PREDICTIONS',
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyFeatureModeTo>(
      {url: `/can-users/internal/api/plan/feature/${feature}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List of all available features for provided company
 */
export const getInternalCompanyFeatures = (
    companyId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<GetInternalCompanyFeatures200>(
      {url: `/can-users/internal/api/plan/company/${companyId}/feature`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get feature information for provided company
 */
export const getInternalCompanyFeature = (
    companyId: number,
    feature: 'MARKET_NEWS' | 'STOCK_EXCHANGE' | 'QUICK_TRADING' | 'PURCHASE_PRICES' | 'TRADING' | 'TRANSACTIONS_ORDERS' | 'STORAGES' | 'MARKETPLACE' | 'YIELD_PREDICTIONS',
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyFeatureModeTo>(
      {url: `/can-users/internal/api/plan/company/${companyId}/feature/${feature}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get all features
 */
export const getAllFeatures = (
    
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<FeatureTo[]>(
      {url: `/can-users/internal/api/feature`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Returns internal company metadata for provided company number
 */
export const getMetadata = (
    country: string,
    company: string,
    user: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyAppMetadata>(
      {url: `/can-users/internal/api/company/${country}/${company}/${user}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Company detail
 */
export const getInternalCompany = (
    companyId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyTo>(
      {url: `/can-users/internal/api/company/${companyId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List of all company users
 */
export const getInternalCompanyUsers = (
    companyId: number,
    params?: GetInternalCompanyUsersParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanySimpleUserTo[]>(
      {url: `/can-users/internal/api/company/${companyId}/user`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Cleanup auth0 test users
 */
export const cleanupAuth0 = (
    
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/e2e/api/user/cleanup`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get user detail [users:user:list or users:*:list]
 */
export const getUser = (
    userId: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<UserTo>(
      {url: `/can-users/api/user/${userId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Permanently delete user and their company relations [users:user:delete]
 */
export const _delete = (
    userId: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/user/${userId}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Get user companies
 */
export const getUserCompany = (
    
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanySimpleUserTo[]>(
      {url: `/can-users/api/user/company`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get subscription detail
 */
export const getSubscription = (
    subscriptionId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<SubscriptionTo>(
      {url: `/can-users/api/subscription/${subscriptionId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Delete manual subscription [users:company:plan]
 */
export const deleteSubscription = (
    subscriptionId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<Subscription>(
      {url: `/can-users/api/subscription/${subscriptionId}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Get plan by provided ID
 */
export const getPlan = (
    planId: number,
    params?: GetPlanParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PlanTo>(
      {url: `/can-users/api/plan/${planId}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary List of all available default features
 */
export const getDefaultFeatures = (
    
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<GetDefaultFeatures200>(
      {url: `/can-users/api/plan/feature`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List of all available plans for provided country
 */
export const getCountryPlans = (
    countryId: string,
    params?: GetCountryPlansParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PlanTo[]>(
      {url: `/can-users/api/plan/country/${countryId}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary List of all plans for provided country including plans assignable from admin only [users:company:plan]
 */
export const getCountryPlansIncludingManual = (
    countryId: string,
    params?: GetCountryPlansIncludingManualParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PlanTo[]>(
      {url: `/can-users/api/plan/country/${countryId}/all`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary List of all available plans for provided company
 */
export const getCompanyPlans = (
    companyId: number,
    params?: GetCompanyPlansParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PlanTo[]>(
      {url: `/can-users/api/plan/company/${companyId}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary List of all available features for provided company
 */
export const getCompanyFeatures = (
    companyId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<GetCompanyFeatures200>(
      {url: `/can-users/api/plan/company/${companyId}/feature`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List of all payments [users:payment:list or users:*:list]
 */
export const getPayments = (
    params?: GetPaymentsParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PaymentPage>(
      {url: `/can-users/api/payment`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get payment by ID
 */
export const getPayment = (
    paymentId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PaymentTo>(
      {url: `/can-users/api/payment/${paymentId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get payment status
 */
export const status = (
    gatewayId: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PaymentTo>(
      {url: `/can-users/api/payment/status/${gatewayId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List of all payments for provided company
 */
export const getCompanyPayments = (
    companyId: number,
    params?: GetCompanyPaymentsParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<PaymentPage>(
      {url: `/can-users/api/payment/company/${companyId}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get invoice in QR format
 */
export const getQR = (
    invoiceId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<string>(
      {url: `/can-users/api/invoice/${invoiceId}/qr`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get invoice in PDF format
 */
export const getInvoice = (
    invoiceId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<string>(
      {url: `/can-users/api/invoice/${invoiceId}/pdf`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List of all available countries
 */
export const getCountries = (
    
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CountryTo[]>(
      {url: `/can-users/api/country`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Country detail
 */
export const getCountry = (
    id: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CountryTo>(
      {url: `/can-users/api/country/${id}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List of all companies [users:company:list or users:*:list]
 */
export const getCompanies = (
    params?: GetCompaniesParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyPage>(
      {url: `/can-users/api/company`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get company by id
 */
export const getCompany = (
    companyId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyTo>(
      {url: `/can-users/api/company/${companyId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List of all users with company relation [users:company:list or users:*:list]
 */
export const getUsersWithCompanyRelation = (
    params?: GetUsersWithCompanyRelationParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyUserPage>(
      {url: `/can-users/api/company/user`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get user company relation [users:company:list or users:*:list]
 */
export const getUserWithCompanyRelation = (
    userCompanyId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<CompanyUserTo>(
      {url: `/can-users/api/company/user/${userCompanyId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get user company relation [users:company:delete]
 */
export const deleteUser = (
    userCompanyId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/company/user/${userCompanyId}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Export all users with company relation to excel [users:company:list or users:*:list]
 */
export const exportUsers = (
    params?: ExportUsersParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<StreamingResponseBody>(
      {url: `/can-users/api/company/user/export`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Export all companies to excel [users:company:list or users:*:list]
 */
export const exportCompanies = (
    params?: ExportCompaniesParams,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<StreamingResponseBody>(
      {url: `/can-users/api/company/export`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Permanently deletes testing users
 */
export const deleteTestUsers = (
    
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/e2e/api/user`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Permanently deletes testing user by email
 */
export const deleteTestUser = (
    email: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<unknown>(
      {url: `/can-users/e2e/api/user/${email}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Permanently deletes company subscription
 */
export const deleteTestCompanySubscription = (
    companyNumber: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/e2e/api/subscription/company/${companyNumber}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Permanently deletes company and all its users
 */
export const deleteTestCompany = (
    companyNumber: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/e2e/api/company/${companyNumber}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Reset user and their company relations [users:user:reset]
 */
export const reset = (
    userId: string,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/user/${userId}/reset`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Delete a custom price for a company [users:company:plan]
 */
export const deleteCustomPrice = (
    companyId: number,
    planPeriodId: number,
 options?: SecondParameter<typeof usersInstance>,) => {
      return usersInstance<void>(
      {url: `/can-users/api/company/${companyId}/custom-price/${planPeriodId}`, method: 'DELETE'
    },
      options);
    }
  
export type E2eSetCustomPriceResult = NonNullable<Awaited<ReturnType<typeof e2eSetCustomPrice>>>
export type E2eDeleteAllCustomPricesResult = NonNullable<Awaited<ReturnType<typeof e2eDeleteAllCustomPrices>>>
export type GetUsersResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type UpdateResult = NonNullable<Awaited<ReturnType<typeof update>>>
export type PatchResult = NonNullable<Awaited<ReturnType<typeof patch>>>
export type BlockResult = NonNullable<Awaited<ReturnType<typeof block>>>
export type UnblockResult = NonNullable<Awaited<ReturnType<typeof unblock>>>
export type CancelSubscriptionResult = NonNullable<Awaited<ReturnType<typeof cancelSubscription>>>
export type ConfirmPaymentResult = NonNullable<Awaited<ReturnType<typeof confirmPayment>>>
export type CancelPaymentResult = NonNullable<Awaited<ReturnType<typeof cancelPayment>>>
export type GetCompanyDetailResult = NonNullable<Awaited<ReturnType<typeof getCompanyDetail>>>
export type UpdateCompanyDetailResult = NonNullable<Awaited<ReturnType<typeof updateCompanyDetail>>>
export type PatchCompanyDetailResult = NonNullable<Awaited<ReturnType<typeof patchCompanyDetail>>>
export type SetCustomPriceResult = NonNullable<Awaited<ReturnType<typeof setCustomPrice>>>
export type SetUserStateDeprecatedResult = NonNullable<Awaited<ReturnType<typeof setUserStateDeprecated>>>
export type SetUserStateResult = NonNullable<Awaited<ReturnType<typeof setUserState>>>
export type SetUserRoleResult = NonNullable<Awaited<ReturnType<typeof setUserRole>>>
export type CreateResult = NonNullable<Awaited<ReturnType<typeof create>>>
export type GetMetadataListResult = NonNullable<Awaited<ReturnType<typeof getMetadataList>>>
export type GetUserCompaniesResult = NonNullable<Awaited<ReturnType<typeof getUserCompanies>>>
export type AssignUserCompanyResult = NonNullable<Awaited<ReturnType<typeof assignUserCompany>>>
export type CreatePaidResult = NonNullable<Awaited<ReturnType<typeof createPaid>>>
export type CreateManualResult = NonNullable<Awaited<ReturnType<typeof createManual>>>
export type GetCompanyUsersResult = NonNullable<Awaited<ReturnType<typeof getCompanyUsers>>>
export type AssignCompanyUserResult = NonNullable<Awaited<ReturnType<typeof assignCompanyUser>>>
export type ValidateResult = NonNullable<Awaited<ReturnType<typeof validate>>>
export type GetLanguagesResult = NonNullable<Awaited<ReturnType<typeof getLanguages>>>
export type GetLanguageResult = NonNullable<Awaited<ReturnType<typeof getLanguage>>>
export type GetAllResult = NonNullable<Awaited<ReturnType<typeof getAll>>>
export type GetInternalUserResult = NonNullable<Awaited<ReturnType<typeof getInternalUser>>>
export type GetByEmailResult = NonNullable<Awaited<ReturnType<typeof getByEmail>>>
export type GetInternalDefaultFeatureResult = NonNullable<Awaited<ReturnType<typeof getInternalDefaultFeature>>>
export type GetInternalCompanyFeaturesResult = NonNullable<Awaited<ReturnType<typeof getInternalCompanyFeatures>>>
export type GetInternalCompanyFeatureResult = NonNullable<Awaited<ReturnType<typeof getInternalCompanyFeature>>>
export type GetAllFeaturesResult = NonNullable<Awaited<ReturnType<typeof getAllFeatures>>>
export type GetMetadataResult = NonNullable<Awaited<ReturnType<typeof getMetadata>>>
export type GetInternalCompanyResult = NonNullable<Awaited<ReturnType<typeof getInternalCompany>>>
export type GetInternalCompanyUsersResult = NonNullable<Awaited<ReturnType<typeof getInternalCompanyUsers>>>
export type CleanupAuth0Result = NonNullable<Awaited<ReturnType<typeof cleanupAuth0>>>
export type GetUserResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type _DeleteResult = NonNullable<Awaited<ReturnType<typeof _delete>>>
export type GetUserCompanyResult = NonNullable<Awaited<ReturnType<typeof getUserCompany>>>
export type GetSubscriptionResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>
export type DeleteSubscriptionResult = NonNullable<Awaited<ReturnType<typeof deleteSubscription>>>
export type GetPlanResult = NonNullable<Awaited<ReturnType<typeof getPlan>>>
export type GetDefaultFeaturesResult = NonNullable<Awaited<ReturnType<typeof getDefaultFeatures>>>
export type GetCountryPlansResult = NonNullable<Awaited<ReturnType<typeof getCountryPlans>>>
export type GetCountryPlansIncludingManualResult = NonNullable<Awaited<ReturnType<typeof getCountryPlansIncludingManual>>>
export type GetCompanyPlansResult = NonNullable<Awaited<ReturnType<typeof getCompanyPlans>>>
export type GetCompanyFeaturesResult = NonNullable<Awaited<ReturnType<typeof getCompanyFeatures>>>
export type GetPaymentsResult = NonNullable<Awaited<ReturnType<typeof getPayments>>>
export type GetPaymentResult = NonNullable<Awaited<ReturnType<typeof getPayment>>>
export type StatusResult = NonNullable<Awaited<ReturnType<typeof status>>>
export type GetCompanyPaymentsResult = NonNullable<Awaited<ReturnType<typeof getCompanyPayments>>>
export type GetQRResult = NonNullable<Awaited<ReturnType<typeof getQR>>>
export type GetInvoiceResult = NonNullable<Awaited<ReturnType<typeof getInvoice>>>
export type GetCountriesResult = NonNullable<Awaited<ReturnType<typeof getCountries>>>
export type GetCountryResult = NonNullable<Awaited<ReturnType<typeof getCountry>>>
export type GetCompaniesResult = NonNullable<Awaited<ReturnType<typeof getCompanies>>>
export type GetCompanyResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetUsersWithCompanyRelationResult = NonNullable<Awaited<ReturnType<typeof getUsersWithCompanyRelation>>>
export type GetUserWithCompanyRelationResult = NonNullable<Awaited<ReturnType<typeof getUserWithCompanyRelation>>>
export type DeleteUserResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
export type ExportUsersResult = NonNullable<Awaited<ReturnType<typeof exportUsers>>>
export type ExportCompaniesResult = NonNullable<Awaited<ReturnType<typeof exportCompanies>>>
export type DeleteTestUsersResult = NonNullable<Awaited<ReturnType<typeof deleteTestUsers>>>
export type DeleteTestUserResult = NonNullable<Awaited<ReturnType<typeof deleteTestUser>>>
export type DeleteTestCompanySubscriptionResult = NonNullable<Awaited<ReturnType<typeof deleteTestCompanySubscription>>>
export type DeleteTestCompanyResult = NonNullable<Awaited<ReturnType<typeof deleteTestCompany>>>
export type ResetResult = NonNullable<Awaited<ReturnType<typeof reset>>>
export type DeleteCustomPriceResult = NonNullable<Awaited<ReturnType<typeof deleteCustomPrice>>>
